module.exports = __webpack_public_path__ + "img/logo.bf092d30.svg";